export default "__VITE_ASSET__DtODE1fo__"